// extracted by mini-css-extract-plugin
module.exports = {"root":"PreferredDesignsForm_root__2KOGz"};